//  this JS script is added in the theme.liquid file so it's available on all pages

// =====================================Apply a product discount based on Cookies=====================

const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);
var visibleDiscount = urlParams.get('visdis');
//console.log(visibleDiscount);
if (visibleDiscount !== null) {
  document.cookie = 'visdis='+ visibleDiscount +'; domain=barecookware.com; path=/';
  console.log('logged cookie');
}

// =====================================Get cookie value based on cookie name=====================
// Should somehow be accessable from the 
  function getCustomCookie(name) {
    var dc = document.cookie;
    var prefix = name + "=";
    var begin = dc.indexOf("; " + prefix);
    if (begin == -1) {
        begin = dc.indexOf(prefix);
        if (begin != 0) return null;
    }
    else
    {
        begin += 2;
        var end = document.cookie.indexOf(";", begin);
        if (end == -1) {
        end = dc.length;
        }
    }
    // because unescape has been deprecated, replaced with decodeURI
    //return unescape(dc.substring(begin + prefix.length, end));
    return decodeURI(dc.substring(begin + prefix.length, end));
} 
// =====================================Code to loop through price field and multiply them by the discount====================


// first loop through the product cards and then do the same vor the PDP prices

window.addEventListener('load', function () {

  var visDisCookie = getCustomCookie("visdis");

    if (visDisCookie !== null && visDisCookie > 0 && visDisCookie < 100 ) {

      var activeDiscount = (100 - visDisCookie)/100;
      setDiscountedPrices(activeDiscount);
      setHeaderMessage(visDisCookie);
      setQuickAddPrice(activeDiscount);
      setTimeout(function(){
       //the recommendations sometimes take a bit to load, so here we delay the function. not a pretty solution
        updateRecommendationPrices(activeDiscount);
        
      }, 2500)

  
    }else{
   
    }
  });

function setDiscountedPrices(discountPercentage) {
// Run through the list of Product cards
let productCardList = document.getElementsByTagName('product-card');
  if (productCardList == null){return;}
for (var i = 0; i < productCardList.length; i++) {
  var salePrice = productCardList[i].getElementsByTagName('sale-price');
  // sets correct classes to show discount
  salePrice[0].classList.add('text-on-sale');
  salePrice[0].classList.remove('text-subdued');
  
  //store the old price for a compare price
  var oldPrice = salePrice[0].textContent;

  //create the new price by splitting innertext of the sale price, drop all whitespace, then split off the ''sale price'' text and the possible ''from '', then the currecy.
  var prefix='';
  if(oldPrice.includes('From')){
    prefix = 'From ';
  }
  oldPrice = oldPrice.replace('Sale price','').replace(/\s/g, '').replace('From', '');
  var currency = oldPrice.charAt(0);
  oldPriceNumber = oldPrice.replace(currency, '');
  oldPriceNumber = Number(oldPriceNumber.replace(',','.'));

  // now calculate the new price
  var newPriceNumber = oldPriceNumber * discountPercentage; 
  // create the complete new price string with currency
  newPrice = (Math.round(newPriceNumber*100)/100).toFixed(2);
  newPrice = prefix + currency + newPrice.replace('.',',')
  
  var savingAmount = oldPriceNumber - newPriceNumber;
  savingAmount = (Math.round(savingAmount*100)/100).toFixed(2);
  savingAmount = prefix + currency + savingAmount.replace('.',',')
  
  //finally set the new price
  salePrice[0].textContent=newPrice;

  // now add the compare at price if there isn't one, this only works on the product cards not on the PDP
  var comparePrice = productCardList[i].getElementsByTagName('compare-at-price');
  if (comparePrice.length <= 0){
    productCardList[i].getElementsByTagName('price-list')[0].innerHTML = productCardList[i].getElementsByTagName('price-list')[0].innerHTML + '<compare-at-price class="text-subdued line-through" style="display: unset !important;">' + oldPrice + '</compare-at-price>';
  }
  //now display a saving badge if none exists
  var salesBadge = productCardList[i].getElementsByClassName('product-card__badge-list');
  if (salesBadge.length <= 0){
    productCardList[i].innerHTML = '<div class="product-card__badge-list"> <on-sale-badge discount-mode="saving" class="badge badge--on-sale">Save ' + savingAmount + '</on-sale-badge> </div>' + productCardList[i].innerHTML;
  }else {
    // here a sales badge exists, but it's very difficult to calculate the exact savings (or at least a lot of work) so we only display 'on sale'
    var existingBadge = productCardList[i].getElementsByClassName('product-card__badge-list');
    existingBadge[0].remove();
    productCardList[i].innerHTML = '<div class="product-card__badge-list"> <on-sale-badge discount-mode="saving" class="badge badge--on-sale">On sale</on-sale-badge> </div>' + productCardList[i].innerHTML;
  }

}

// Now we do the same for the product price
let productPDPPrice = document.getElementsByClassName('product-info__price'); 
for (var i = 0; i < productPDPPrice.length; i++) {
  var salePrice = productPDPPrice[i].getElementsByTagName('sale-price');
  // sets correct classes to show discount
  salePrice[0].classList.add('text-on-sale');
  salePrice[0].classList.remove('text-subdued');
  
  //store the old price for a compare price
  var oldPrice = salePrice[0].textContent;

  //create the new price by splitting innertext of the sale price, drop all whitespace, then split off the ''sale price'' text and the possible ''from '', then the currecy.
  var prefix='';
  if(oldPrice.includes('From')){
    prefix = 'From ';
  }
  oldPrice = oldPrice.replace('Sale price','').replace(/\s/g, '').replace('From', '');
  var currency = oldPrice.charAt(0);
  oldPriceNumber = oldPrice.replace(currency, '');
  oldPriceNumber = Number(oldPriceNumber.replace(',','.'));

  // now calculate the new price
  var newPriceNumber = oldPriceNumber * discountPercentage; 
  // create the complete new price string with currency
  newPrice = (Math.round(newPriceNumber*100)/100).toFixed(2);
  newPrice = prefix + currency + newPrice.replace('.',',')
  
  var savingAmount = oldPriceNumber - newPriceNumber;
  savingAmount = (Math.round(savingAmount*100)/100).toFixed(2);
  savingAmount = prefix + currency + savingAmount.replace('.',',')
  
  //finally set the new price
  salePrice[0].textContent=newPrice;

  // now add the compare at price if there isn't one
  var comparePrice = productPDPPrice[i].getElementsByTagName('compare-at-price');
  productPDPPrice[i].getElementsByTagName('compare-at-price')[0].removeAttribute("hidden");

  //now display a saving badge if none exists

  
  var salesBadge = productPDPPrice[i].getElementsByTagName('on-sale-badge');
  var badgeWrapper = productPDPPrice[i].getElementsByClassName('product-info__badge-list');

  if (salesBadge[0].hasAttribute('hidden')){
    salesBadge[0].remove();
    badgeWrapper[0].innerHTML = badgeWrapper[0].innerHTML + ' <on-sale-badge discount-mode="saving" class="badge badge--on-sale">Save ' + savingAmount + '</on-sale-badge>';
    }
    else {
    // here a sales badge exists, but it's very difficult to calculate the exact savings so we only display 'on sale'
    salesBadge[0].remove();
    badgeWrapper[0].innerHTML = badgeWrapper[0].innerHTML + '<on-sale-badge discount-mode="saving" class="badge badge--on-sale">On sale</on-sale-badge>';
      }
  

}

}
function updateRecommendationPrices(discountPercentage){
    
  // Now we do the same for horizontal product cards
// first select by product-recommendations otherwise you also get cart stuff, do you want the cart stuff?
let productRecommendation = document.getElementsByClassName('product-info__complementary-products')[0];
    if (productRecommendation == null) {return;}
let productHorizontalCardList = productRecommendation.getElementsByClassName('horizontal-product');
if (productHorizontalCardList == null) {return;}
for (var i = 0; i < productHorizontalCardList.length; i++) {
  var salePrice = productHorizontalCardList[i].getElementsByTagName('sale-price');
  //store the old price for a compare price
  var oldPrice = salePrice[0].textContent;
  //create the new price by splitting innertext of the sale price, drop all whitespace, then split off the ''sale price'' text and the possible ''from '', then the currecy.
  var prefix='';
  if(oldPrice.includes('From')){
    prefix = 'From ';
  }
  oldPrice = oldPrice.replace('Sale price','').replace(/\s/g, '').replace('From', '');
  var currency = oldPrice.charAt(0);
  oldPriceNumber = oldPrice.replace(currency, '');
  oldPriceNumber = Number(oldPriceNumber.replace(',','.'));

  // now calculate the new price
  var newPriceNumber = oldPriceNumber * discountPercentage; 
  // create the complete new price string with currency
  newPrice = (Math.round(newPriceNumber*100)/100).toFixed(2);
  newPrice = prefix + currency + newPrice.replace('.',',')
  
  var savingAmount = oldPriceNumber - newPriceNumber;
  savingAmount = (Math.round(savingAmount*100)/100).toFixed(2);
  savingAmount = prefix + currency + savingAmount.replace('.',',')
  
  //finally set the new price
  salePrice[0].textContent=newPrice;
    
  // now add the compare at price if there isn't one, this only works on the product cards not on the PDP
  var comparePrice = productHorizontalCardList[i].getElementsByTagName('compare-at-price');
  if (comparePrice.length <= 0){
    productHorizontalCardList[i].getElementsByClassName('v-stack')[0].innerHTML = productHorizontalCardList[i].getElementsByClassName('v-stack')[0].innerHTML + '<compare-at-price class="text-subdued line-through text-sm" style="display: unset !important;">' + oldPrice + '</compare-at-price>';
  }
  }
}
function setQuickAddPrice(discountPercentage){
  let productQuickAdd = document.getElementsByTagName('product-quick-add');
  if (productQuickAdd == null){return;}
for (var i = 0; i < productQuickAdd.length; i++) {
  var salePrice = productQuickAdd[i].getElementsByTagName('sale-price');
  // sets correct classes to show discount
  salePrice[0].classList.add('text-on-sale');
  salePrice[0].classList.remove('text-subdued');
  
  //store the old price for a compare price
  var oldPrice = salePrice[0].textContent;

  //create the new price by splitting innertext of the sale price, drop all whitespace, then split off the ''sale price'' text and the possible ''from '', then the currecy.
  var prefix='';
  if(oldPrice.includes('From')){
    prefix = 'From ';
  }
  oldPrice = oldPrice.replace('Sale price','').replace(/\s/g, '').replace('From', '');
  var currency = oldPrice.charAt(0);
  oldPriceNumber = oldPrice.replace(currency, '');
  oldPriceNumber = Number(oldPriceNumber.replace(',','.'));

  // now calculate the new price
  var newPriceNumber = oldPriceNumber * discountPercentage; 
  // create the complete new price string with currency
  newPrice = (Math.round(newPriceNumber*100)/100).toFixed(2);
  newPrice = prefix + currency + newPrice.replace('.',',')
  
  var savingAmount = oldPriceNumber - newPriceNumber;
  savingAmount = (Math.round(savingAmount*100)/100).toFixed(2);
  savingAmount = prefix + currency + savingAmount.replace('.',',')
  
  //finally set the new price
  salePrice[0].textContent=newPrice;

  // now add the compare at price if there isn't one, this only works on the product cards not on the PDP
  var comparePrice = productQuickAdd[i].getElementsByTagName('compare-at-price');
  
  if (comparePrice[0].hasAttribute('hidden')){
    comparePrice[0].removeAttribute('hidden');
      }
  


}
}
function setHeaderMessage(discountPercentage){

  let storeHeader = document.getElementsByTagName('header');
  if (storeHeader[0] == null){return;}
  const header= '<div class="announcement-bar bg-custom text-custom" style="--background: 26 26 26; --text-color: 255 255 255;"> <marquee-text scrolling-speed="10" class="announcement-bar__scrolling-list" style="--marquee-animation-duration: 6s;"> <span class="announcement-bar__item"> <p class="bold text-xs"> Enjoy a '+ discountPercentage +'% discount store-wide!</p><span class="shape-circle shape--sm"></span> </span> <span class="announcement-bar__item"> <p class="bold text-xs"> Enjoy a '+ discountPercentage +'% discount store-wide!</p> <span class="shape-circle shape--sm"></span> </span> <span class="announcement-bar__item"> <p class="bold text-xs"> Enjoy a '+ discountPercentage +'% discount store-wide!</p> <span class="shape-circle shape--sm"></span> </span> <span class="announcement-bar__item"> <p class="bold text-xs"> Enjoy a '+ discountPercentage +'% discount store-wide!</p> <span class="shape-circle shape--sm"></span> </span> <span class="announcement-bar__item"> <p class="bold text-xs"> Enjoy a '+ discountPercentage +'% discount store-wide!</p> <span class="shape-circle shape--sm"></span> </span> <span class="announcement-bar__item"> <p class="bold text-xs"> Enjoy a '+ discountPercentage +'% discount store-wide!</p> <span class="shape-circle shape--sm"></span> </span> </span> <span class="announcement-bar__item"> <p class="bold text-xs"> Enjoy a '+ discountPercentage +'% discount store-wide!</p> <span class="shape-circle shape--sm"></span> </span> </span> <span class="announcement-bar__item"> <p class="bold text-xs"> Enjoy a '+ discountPercentage +'% discount store-wide!</p> <span class="shape-circle shape--sm"></span> </span> </span> <span class="announcement-bar__item"> <p class="bold text-xs"> Enjoy a '+ discountPercentage +'% discount store-wide!</p> <span class="shape-circle shape--sm"></span> </span> </marquee-text> </div>';
  storeHeader[0].insertAdjacentHTML("afterbegin", header);   
}

